import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { ConfirmProvider } from './components/ui/ConfirmDialog';
import { ToastContainer } from './components/ui/ToastContainer';
import { PWAUpdatePrompt } from './components/pwa/PWAUpdatePrompt';
import { InstallBanner } from './components/pwa/InstallBanner';
import { SyncStatus } from './components/SyncStatus';
import './index.css';
import './styles/dashboard.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <ConfirmProvider>
          <AuthProvider>
            <App />
            <ToastContainer />
            <PWAUpdatePrompt />
            <InstallBanner />
            <SyncStatus />
          </AuthProvider>
        </ConfirmProvider>
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);